export const SMARTY_STREETS = {
  API_KEY: '5559207189114974',
  ZIP_URL: 'https://us-zipcode.api.smartystreets.com/lookup',
  AUTOCOMPLETE_URL: 'https://us-autocomplete-pro.api.smartystreets.com/lookup',
  STREET_ADDRESS_URL: 'https://us-street.api.smartystreets.com/street-address',
};

export default SMARTY_STREETS;
